import { useMutation } from '@tanstack/react-query';
import { patchMyPokeTractor } from '../../../../api/user/mutations/patchMyPokeTractor';

export const usePatchMyPokeTractor = () => {
  return useMutation(patchMyPokeTractor);
};
